import { useRef } from 'react';
import React from 'react';
import { LayerHandleV1, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';

import { ManageDealerLayerViewProps } from '../../components/ManageDealerLayerContent/ManageDealerLayerContentView';
import { useManageDealerLayerData } from '../../components/ManageDealerLayerContent/hooks/useManageDealerLayerData';
import { BRIDGE_KEYS, LayerDataBridge } from '../../../../shared/utils/layer-data-bridge';
import { useLayerManager } from '../../../../shared/hooks/use-layer-manager';

type DealerLayerRenderFn = (
  state: { dataBridge: LayerDataBridge<ManageDealerLayerViewProps> },
  close: any,
) => JSX.Element;

export const useDealerLayer = (active: boolean, onClose: () => void, renderFn: DealerLayerRenderFn) => {
  const layerManager = useLayerManager();
  const hasOpenedRef = useRef(false);
  const layerHandle = useRef<LayerHandleV1<{ dataBridge: LayerDataBridge<ManageDealerLayerViewProps> }> | null>(null);
  const bridge = LayerDataBridge.getInstance<ManageDealerLayerViewProps>(BRIDGE_KEYS.DEALER);
  const dealerData = useManageDealerLayerData();

  React.useEffect(() => {
    if (!active) return;
    bridge.setData({ ...dealerData, onDealerSelect: () => layerHandle.current?.close() });
  }, [active, dealerData]);

  React.useEffect(() => {
    if (active && !hasOpenedRef.current && layerManager) {
      hasOpenedRef.current = true;
      bridge.setData({ ...dealerData, onDealerSelect: () => layerHandle.current?.close() });
      layerHandle.current = layerManager.openInteractionLayer(
        renderFn,
        { dataBridge: bridge },
        {
          size: 'E' as any,
          shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
          onClose: (_state: any, _response: any) => {
            hasOpenedRef.current = false;
            bridge.setData(null);
            onClose();
          },
        },
      );
    }
    if (!active) {
      hasOpenedRef.current = false;
    }
  }, [active]);
};
